module.exports = __webpack_public_path__ + "static/media/image_10.ed07fca2.jpg";